import PropTypes from 'prop-types';
import { memo, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Map from '../../Map';
import ShowHideTripItinerariesMap from '../../../TravelOptionsPagination/ShowHideTripItinerariesMap';
import SortingFilter from '../../../Filters/SortingFilter';
import TourFilters from '../TourFilters';
import TourList from '../TourList';
import TourPagination from '../TourPagination';
import PollingSearchProgressBar from '../../../PollingSearchProgressBar';
import { setTourTripSearchParam, tourSearchRequest } from '../../../../store/slices/tripSearch';
import { SearchModes, TourFiltersInitialValue, TourSortingValues } from '../../../../constants';

const ToursModalContent = ({ tripId, onViewLessClick }) => {
  const dispatch = useDispatch();
  const [tourToScroll, setTourToScroll] = useState(null);
  const isTripSearch = !tripId;
  const searchObj = useSelector((store) => store.tripSearch.searchObj.tour);
  const isMapShown = useSelector((store) => store.tripSearch.isMapShown);

  const search = useCallback(
    (params) => {
      dispatch(setTourTripSearchParam(params));
      dispatch(tourSearchRequest({ isTripSearch, tripId }));
    },
    [dispatch, isTripSearch, tripId],
  );

  const handleSortChange = useCallback((sorting) => search({ ...sorting, page: 1 }), [search]);

  const handleMarkerClick = useCallback(
    (markerKey, pageNumber) => {
      setTourToScroll(markerKey);
      if (pageNumber && pageNumber !== (searchObj?.page || 1)) {
        search({ page: pageNumber });
      }
    },
    [search, searchObj],
  );

  return (
    <>
      <PollingSearchProgressBar tripId={tripId} searchMode={SearchModes.TOUR} />
      <div className="flex justify-center w-full">
        <div className="p-5 flex-shrink flex-grow min-w-0">
          <div className="font-bold flex justify-between items-center gap-2">
            All tours
            <ShowHideTripItinerariesMap />
            <SortingFilter
              sortingValues={TourSortingValues}
              initialValue={TourFiltersInitialValue.sortBy}
              value={searchObj?.sortBy}
              direction={searchObj?.sortDirection}
              onSortChange={handleSortChange}
              variant="transparentOutline"
            />
          </div>
          <TourPagination tripId={tripId} className="mb-5" doShowLoadMore />
          <TourFilters tripId={tripId} />
          <TourList
            tripId={tripId}
            isInsideModal
            tourToScroll={tourToScroll}
            onViewMoreClick={onViewLessClick}
            onModalClose={onViewLessClick}
          />
          <div className="mb-5">
            <TourPagination tripId={tripId} />
          </div>
        </div>
        {isMapShown && (
          <Map tripId={tripId} searchMode={SearchModes.TOUR} onMarkerClick={handleMarkerClick} />
        )}
      </div>
    </>
  );
};

ToursModalContent.propTypes = {
  tripId: PropTypes.string,
  onViewLessClick: PropTypes.func.isRequired,
};

ToursModalContent.defaultProps = {
  tripId: undefined,
};

export default memo(ToursModalContent);
